import React, { forwardRef, useState, useImperativeHandle, useRef } from "react";
import { Typography } from "@mui/material";
import PlainTextField from "../../components/InputField/PlainTextField";
import Stack from "@mui/material/Stack";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import { Input } from "../../components/Input";
import * as util from "util"; // has no default export
import { inspect } from "util"; // or directly

const PersonName = forwardRef((props, ref) => {
    const firstNameRef = useRef();
    const lastNameRef = useRef();

    const refs = [firstNameRef, lastNameRef];

    const [formValues, setFormValues] = useState(
        props.value ? props.value : { firstName: "", middleName: "", lastName: "" }
    );
    const [hasMiddleName, setHasMiddleName] = useState(props.value?.middleName ? true : false);
    const [hasError, setHasError] = useState(false);

    useImperativeHandle(ref, () => ({
        validate,
    }));

    const validate = () => {
        let valid = false;
        for (let i = 0; i < refs.length; i++) {
            if (!refs[i].current.validate()) {
                valid = true;
            }
        }

        setHasError(!valid);
        return !valid;
    };

    const addFormFields = (event) => {
        setHasMiddleName(true);
    };

    const removeFormFields = (event) => {
        let newFormValues = formValues;
        newFormValues["middleName"] = "";
        setHasMiddleName(false);
    };

    const handleChange = (id, value) => {
        let newFormValues = formValues;
        newFormValues[id] = value;
        setFormValues(newFormValues);
        props.onChange({ ...newFormValues, hasMiddleName: hasMiddleName });
    };

    return (
        <div>
            <Input
                {...props.rest}
                id="firstName"
                ref={firstNameRef}
                value={formValues.firstName}
                label="First name"
                name="firstName"
                margin="normal"
                isRequired={true}
                fullWidth
                onChange={(value) => handleChange("firstName", value)}
            />
            <Input
                {...props.rest}
                id="lastName"
                ref={lastNameRef}
                value={formValues.lastName}
                label="Last name"
                name="lastName"
                margin="normal"
                fullWidth
                isRequired={true}
                onChange={(value) => handleChange("lastName", value)}
            />
            {hasMiddleName ? (
                <>
                    <Input
                        {...props.rest}
                        id="middleName"
                        label="Middle name"
                        name="middleName"
                        value={formValues.middleName}
                        margin="normal"
                        fullWidth
                        isRequired={false}
                        onChange={(value) => handleChange("middleName", value)}
                    />

                    <Stack direction="row" spacing={2} sx={{ mt: 1, mb: 1 }} onClick={removeFormFields}>
                        <RemoveCircleOutlineOutlinedIcon color="primary" />
                        <Typography
                            variant="h6"
                            display="block"
                            gutterBottom
                            color="primary.main"
                            sx={{
                                textTransform: "none",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <b>Remove middle name</b>
                        </Typography>
                    </Stack>
                </>
            ) : (
                <Stack direction="row" spacing={2} sx={{ mt: 1, mb: 1 }} onClick={addFormFields}>
                    <AddCircleOutlineOutlinedIcon color="primary" />
                    <Typography
                        variant="h6"
                        display="block"
                        gutterBottom
                        color="primary.main"
                        sx={{
                            textTransform: "none",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <b>Add middle name</b>
                    </Typography>
                </Stack>
            )}
        </div>
    );
});

export { PersonName };
